import Fuse from 'fuse.js';

export type SelectGroupOption<Value = number | string, Data = any> = {
  value: Value;
  label: string;
  /**
   * If you want an alternative label for value vs option label
   */
  optionLabel?: string;
  color?: string;
  icon?: string;
  iconNamespace?: string;
  data?: Data;
};

export type SelectGroupCategory<CategoryValueType = number | string, ItemValueType = number, ItemData = any> = {
  value: CategoryValueType;
  label: string;
  icon?: string;
  iconColor?: string;
  iconNamespace?: string;
  items: SelectGroupOption<ItemValueType, ItemData>[];
  lazyLoad?: boolean;
  fetch?: () => Promise<SelectGroupOption<ItemValueType, ItemData>[]>;

  /**
   * Flag which fetcher we use for user search since no data
   * is potentially loaded when user starts typing with lazy loading
   */
  usedForUserSearch?: boolean;
  /**
   * On picker open this will show the category open by default
   */
  openByDefault?: boolean;
  shouldHide?: boolean;
};

export type OptionItem<Value = number, Data = any> = SelectGroupOption<Value, Data> & {
  category: {
    value: any;
    label: string;
    icon?: string;
    iconColor?: string;
  };
};

export type CategoryItem<CategoryValueType = number | string, ItemValueType = number, ItemData = any> = Omit<
  SelectGroupCategory<CategoryValueType, ItemValueType, ItemData>,
  'items'
>;

export enum SelectType {
  CATEGORY = 'category',
  OPTION = 'list',
}

export type SearchAdapter = Fuse<OptionItem>;
